import * as moment from 'moment';

export const titleStatisticWebPage = "CNTT 108 viện 108";

export const DATE_TIME_REACT_FORMAT = 'dd/MM/yyyy HH:mm';
export const DATE_TIME_REACT_FORMAT_TYPE_ONE = 'DD/MM/YYYY HH:mm';
export const DATE_TIME_REACT_WITHOUT_HOUR_FORMAT = 'dd/MM/yyyy';
export const DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT = 'DD/MM/YYYY';
export const ID_EMPTY = '00000000-0000-0000-0000-000000000000';

export const timeStep = 15;
export const TOKEN_KEY = 'auth_auth_server_cntt_108';
export const ID_TOKEN_KEY = 'auth_identity_auth_server_cntt_108';
export const REFRESH_TOKEN_KEY = 'auth_refresh_token_auth_server_cntt_108';
export const EXPIRY_KEY = 'auth_expire_auth_server_cntt_108';
export const FLASH_KEY = 'flash';
export const LOGIN_SSO_ORIGIN_KEY = 'login_sso_origin_auth_server_cntt_108';
export const CRAWLER_SLUGNAME = 'baogia_tnh99';
export const acceptImage = 'image/png,image/jpg,image/jpeg,image/gif';
export const acceptDoc = 'image/png,image/jpg,image/jpeg,image/gif,application/pdf';
export const acceptAllDoc = '*/*';
export const acceptZip = 'application/zip';
export const acceptVideo = 'video/mp4,video/x-m4v,video/*';
export const status200 = 200;
export const status201 = 201;
export const status400 = 400;

export const invoiceStatusValue = {
  YeuCauPhatHanh: 0,
  PhatHanh: 1,
  DaKeKhaiThue: 2,
  BiThayThe: 3,
  BiDieuChinh: 4,
  Huy: 5,
  YeuCauThayThe: 6,
  YeuCauDieuChinhGiam: 7,
  YeuCauHuy: 8
};

export const objectInvoiceStatus = [
  { label: 'Yêu cầu phát hành', value: invoiceStatusValue.YeuCauPhatHanh },
  { label: 'Đã phát hành', value: invoiceStatusValue.PhatHanh },
  { label: 'Đã kê khai thuế', value: invoiceStatusValue.DaKeKhaiThue },
  { label: 'Bị thay thế', value: invoiceStatusValue.BiThayThe },
  { label: 'Bị điều chỉnh', value: invoiceStatusValue.BiDieuChinh },
  { label: 'Đã hủy', value: invoiceStatusValue.Huy },
  { label: 'Yêu cầu thay thế', value: invoiceStatusValue.YeuCauThayThe },
  { label: 'Yêu cầu điều chỉnh giảm', value: invoiceStatusValue.YeuCauDieuChinhGiam },
  { label: 'Yêu cầu hủy', value: invoiceStatusValue.YeuCauHuy }
];

export const invoiceTypeValue = {
  ThongThuong: 0,
  ThayThe: 1,
  DieuChinhTang: 2,
  DieuChinhGiam: 3,
  DieuChinhThongTin: 4
};

export const objectInvoiceType = [
  { label: 'Thông thường', value: invoiceTypeValue.ThongThuong },
  { label: 'Thay thế', value: invoiceTypeValue.ThayThe },
  { label: 'Điều chỉnh tăng', value: invoiceTypeValue.DieuChinhTang },
  { label: 'Điều chỉnh giảm', value: invoiceTypeValue.DieuChinhGiam },
  { label: 'Điều chỉnh thông tin', value: invoiceTypeValue.DieuChinhThongTin }
];

// export let refreshingPromise = null;

export const levelMessage = {
  error: 'error',
  info: 'info',
  warning: 'warning',
  success: 'success'
};

export const postStatus = {
  all: '',
  release: 'release',
  draft: 'draft',
  pending: 'pending',
  refuse: 'refuse'
};

export const dataChoosePlantProcedure = {
  all: 'all',
  choose: 'choose',
};

export const objectDataChoosePlantProcedure = [
  { label: 'Tất cả', value: dataChoosePlantProcedure.all },
  { label: 'Đã chọn quy trình', value: dataChoosePlantProcedure.choose },
];


export const dataOSSystem = {
  ios: 'ios',
  android: 'android',
};

export const sentenceType = {
  noChoose: 'noChoose',
  firstQuestion: 'firstQuestion',
  endedQuestion: 'endedQuestion',
  guidedSentence: 'guidedSentence',
  secondToEndQuestion: 'secondToEndQuestion',
};

export const objectSentenceType = [
  { label: 'Không chọn', value: sentenceType.noChoose },
  { label: 'Câu hỏi đầu tiên', value: sentenceType.firstQuestion },
  { label: 'Câu hỏi cuối cùng', value: sentenceType.endedQuestion },
  { label: 'Câu hỏi thứ 2 gần cuối', value: sentenceType.secondToEndQuestion },
  { label: 'Câu hướng dẫn', value: sentenceType.guidedSentence },
];

export const answerChoice = {
  noChoose: 'noChoose',
  yesChoice: 'yesChoice',
  noChoice: 'noChoice',
};

export const objectAnswerChoice = [
  { label: 'Không chọn', value: answerChoice.noChoose },
  { label: 'Có', value: answerChoice.yesChoice },
  { label: 'Không', value: answerChoice.noChoice },
];

export const roleAccount = {
  ADMIN: 'ADMIN',
  QTCPMHLDT: 'QTCPMHLDT',
  KHTH: 'KHTH',
  HLDT: 'HLDT'
};

export const objectRoleAccount = [
  { label: 'Quyền truy cập Phần mềm Huấn luyện đào tạo', value: roleAccount.QTCPMHLDT },
  { label: 'Kế hoạch tổng hợp', value: roleAccount.KHTH },
  { label: 'Huấn luyện đào tạo', value: roleAccount.HLDT },
  { label: 'Quản trị hệ thống', value: roleAccount.ADMIN }
];

export const typeQA = {
  question: 'question',
  answer: 'answer',
};

export const objectTypeQA = [
  { label: 'Câu hỏi', value: typeQA.question },
  { label: 'Câu trả lời', value: typeQA.answer },
];

export const trangThaiDeNghiValue = {
  chuaXuLy: 'chuaXuLy',
  dangXuLy: 'dangXuLy',
  daXuLy: 'daXuLy',
  all: 'all'
};

export const objectTrangThaiDeNghi = [
  { label: 'Tất cả', value: trangThaiDeNghiValue.all },
  { label: 'Chưa xử lý', value: trangThaiDeNghiValue.chuaXuLy },
  { label: 'Đang xử lý', value: trangThaiDeNghiValue.dangXuLy },
  { label: 'Đã xử lý', value: trangThaiDeNghiValue.daXuLy },
];

export const loaiNoiDungValue = {
  noidungdenghi: 'noidungdenghi',
  chinhsuabaohiem: 'chinhsuabaohiem',
  all: 'all'
};

export const objectLoaiNoiDung = [
  { label: 'Tất cả', value: loaiNoiDungValue.all },
  { label: 'Nội dung đề nghị', value: loaiNoiDungValue.noidungdenghi },
  { label: 'Chỉnh sửa bảo hiểm', value: loaiNoiDungValue.chinhsuabaohiem },
];


export const trangThaiDangKyDuTuyenValue = {
  moiDangKy: 'moiDangKy',
  choTiepNhan: 'choTiepNhan',
  daTiepNhan: 'daTiepNhan',
  choCapTaiKhoan: 'choCapTaiKhoan',
  daCapTaiKhoan: 'daCapTaiKhoan',
  choTaoHoSo: 'choTaoHoSo',
  daTaoHoSo: 'daTaoHoSo',
  tuChoi: 'tuChoi',
  huy: 'huy',
  all: 'all'
};

export const objectTrangThaiDangKyDuTuyen = [
  { label: 'Tất cả', value: trangThaiDangKyDuTuyenValue.all },
  { label: 'Mới đăng ký', value: trangThaiDangKyDuTuyenValue.moiDangKy },
  { label: 'Chờ tiếp nhận', value: trangThaiDangKyDuTuyenValue.choTiepNhan },
  { label: 'Đã tiếp nhận', value: trangThaiDangKyDuTuyenValue.daTiepNhan },
  { label: 'Chờ cấp tài khoản', value: trangThaiDangKyDuTuyenValue.choCapTaiKhoan },
  { label: 'Đã cấp tài khoản', value: trangThaiDangKyDuTuyenValue.daCapTaiKhoan },
  { label: 'Chờ tạo hồ sơ', value: trangThaiDangKyDuTuyenValue.choTaoHoSo },
  { label: 'Đã tạo hồ sơ', value: trangThaiDangKyDuTuyenValue.daTaoHoSo },
  { label: 'Từ chối', value: trangThaiDangKyDuTuyenValue.tuChoi },
  { label: 'Hủy', value: trangThaiDangKyDuTuyenValue.huy },
];

export const trangThaiHoSoDuTuyenValue = {
  choGui: 0,
  choDuyet: 1,
  canChinhSua: 2,
  duyet: 3,
  tuChoi: 4
};

export const objectTrangThaiHoSoDuTuyen = [
  { label: 'Chờ gửi', value: trangThaiHoSoDuTuyenValue.choGui },
  { label: 'Chờ duyệt', value: trangThaiHoSoDuTuyenValue.choDuyet },
  { label: 'Cần chỉnh sửa', value: trangThaiHoSoDuTuyenValue.canChinhSua },
  { label: 'Duyệt', value: trangThaiHoSoDuTuyenValue.duyet },
  { label: 'Từ chối', value: trangThaiHoSoDuTuyenValue.tuChoi },
];

export const trangThaiDotTuyenSinhValue = {
  sapMo: 0,
  dangMo: 1,
  daDong: 2,
  tamDung: 3
};

export const objectTrangThaiDotTuyenSinh = [
  { label: 'Sắp mở', value: trangThaiDotTuyenSinhValue.sapMo },
  { label: 'Đang mở', value: trangThaiDotTuyenSinhValue.dangMo },
  { label: 'Đã đóng', value: trangThaiDotTuyenSinhValue.daDong },
  { label: 'Tạm dừng', value: trangThaiDotTuyenSinhValue.tamDung }
];

export const loaiTuyenSinhValue = {
  tuyenSinhTienSi: 0,
  tuyenSinhDTLT: 1,
  tuyenSinhDTTH: 2
};

export const objectLoaiTuyenSinh = [
  { label: 'Tuyển sinh Tiến sĩ', value: loaiTuyenSinhValue.tuyenSinhTienSi },
  { label: 'Tuyển sinh Đào tạo liên tục', value: loaiTuyenSinhValue.tuyenSinhDTLT },
  { label: 'Tuyển sinh Đào tạo thực hành', value: loaiTuyenSinhValue.tuyenSinhDTTH }
];

export const loaiVanBangValue = {
  nuocNgoai: 1,
  vanBangTrongNuoc: 2
};

export const objectLoaiVanBang = [
  { label: 'Ngoài nước', value: loaiVanBangValue.nuocNgoai },
  { label: 'Trong nước', value: loaiVanBangValue.vanBangTrongNuoc }
];

export const doiTuongValue = {
  quan: 1,
  khac: 2,
  quanVaDan: 3
};

export const objectDoiTuong = [
  { label: 'Quân', value: doiTuongValue.quan },
  { label: 'Dân', value: doiTuongValue.khac },
  { label: 'Quân và dân', value: doiTuongValue.quanVaDan }
];

export const gioiTinh = {
  nam: 'nam',
  nu: 'nu'
};

export const objectGioiTinh = [
  { label: 'Nam', value: gioiTinh.nam },
  { label: 'Nữ', value: gioiTinh.nu }
];

export const loai = {
  them: 'them',
  sua: 'sua',
  xoa: 'xoa',
  chon: 'chon',
  koChon: 'koChon',
};

export const objectLoai = [
  { label: 'Thêm', value: loai.them },
  { label: 'Sửa', value: loai.sua },
  { label: 'Xoá', value: loai.xoa },
  { label: 'Chọn', value: loai.chon },
  { label: 'Không chọn', value: loai.koChon },
];

export const loaiXuLy = {
  tuXuLy: 'tuXuLy',
  doiTacXuLy: 'doiTacXuLy',
  koChon: 'koChon',
};

export const objectLoaiXuLy = [
  { label: 'Tự xử lý', value: loaiXuLy.tuXuLy },
  { label: 'Đối tác xử lý', value: loaiXuLy.doiTacXuLy },
  { label: 'Không chọn', value: loai.koChon },
];

export const sortByValue = {
  ngayDeNghi: 'ngayDeNghi',
  tienChenhLech: 'tienChenhLech',
  tienBaoHiem: 'tienBaoHiem',
};

export const objectDataOSSystem = [
  { label: 'IOS', value: dataOSSystem.ios },
  { label: 'Android', value: dataOSSystem.android },
];

export const objectFertilizerComponent = [
  { label: 'N', value: "n" },
  { label: 'P', value: "p" },
  { label: 'K', value: "k" },
  { label: 'Đạm', value: "protein" },
  { label: '1% đến 20%', value: "rangeFirst" },
  { label: '20% đến 40%', value: "rangeSecond" },
  { label: '40% đến 60%', value: "rangeThird" },
  { label: '60% đến 80%', value: "rangeFourth" },
  { label: '80% đến 100%', value: "rangeFifth" }
];

export const objectStatusPost = [
  { label: 'Tất cả', value: postStatus.all },
  { label: 'Đã duyệt', value: postStatus.release },
  { label: 'Bản nháp', value: postStatus.draft },
  { label: 'Chờ duyệt', value: postStatus.pending },
  { label: 'Từ chối', value: postStatus.refuse }
];

export const dataTypeCategory = {
  all: '',
  information: 'information',
  video: 'video',
  image: 'image',
  introduce: 'introduce'
};

export const objectDataTypeCategory = [
  { label: 'Danh sách tin tức', value: dataTypeCategory.information },
  { label: 'Danh sách video', value: dataTypeCategory.video },
  { label: 'Danh sách ảnh', value: dataTypeCategory.image },
  { label: 'Giới thiệu', value: dataTypeCategory.introduce },
];

export const dataTypeVideo = {
  none: 'none',
  all: "all",
  program: "program",
  tvc: "tvc",
  qc: "qc",
};
export const objectDataTypeVideo = [
  { label: 'Không phải video', value: dataTypeVideo.none },
  { label: 'Video', value: dataTypeVideo.all },
  { label: 'Video Chương trình', value: dataTypeVideo.program },
  { label: 'Video Doanh nghiệp', value: dataTypeVideo.tvc },
  { label: 'Video Quảng Cáo', value: dataTypeVideo.qc },
];

export const objectShowNumber = [
  { text: '5', value: 5 },
  { text: '20', value: 20 },
  { text: '50', value: 50 },
  { text: '100', value: 100 }
];

export const reportPost = {
  ByStatus: 'ByStatus',
  ByCreatedDate: 'ByCreatedDate',
  ByPublicDate: 'ByPublicDate',
  DataType: 'DataType',
  Author: 'Author',
  Category: 'Category'
};
export const reportAdvertisingAnalysis = {
  ByImageThumb: 'ByImageThumb',
  ByDate: 'ByDate',
  ByCategoryId: 'ByCategoryId',
};
export const objectReportAdvertisingAnalysis = [
  { text: 'Link quảng cáo', value: reportAdvertisingAnalysis.ByImageThumb },
  { text: 'Ngày ', value: reportAdvertisingAnalysis.ByDate },
  { text: 'Danh mục', value: reportAdvertisingAnalysis.ByCategoryId },
];

export const loaiKy = {
  BCY: 'BCY',
  SIM: 'SIM',
};
export const objectLoaiKy = [
  { text: 'BCY', value: loaiKy.BCY },
  { text: 'SIM', value: loaiKy.SIM },
];

export const chuKy = {
  TPDIEUDUONG: 'chuky_tpdieuduong',
  // THUKY: 'chuky_thuky',
};

export const objectChuKy = [
  { text: 'TP Điều dưỡng', value: chuKy.TPDIEUDUONG },
  // { text: 'Thư ký', value: chuKy.THUKY },
];

export const chuKyBienBan = {
  CHUTRI: 'chuky_chutri',
  THUKY: 'chuky_thuky',
};

export const objectChuKyBienBan = [
  { text: 'Chủ trì', value: chuKyBienBan.CHUTRI },
  { text: 'Thư ký', value: chuKyBienBan.THUKY },
];

export const objectReportPost = [
  { text: 'Trạng thái', value: reportPost.ByStatus },
  { text: 'Ngày tạo', value: reportPost.ByCreatedDate },
  { text: 'Ngày xuất bản', value: reportPost.ByPublicDate },
  { text: 'Loại', value: reportPost.DataType },
  { text: 'Người tạo', value: reportPost.Author },
  { text: 'Danh mục', value: reportPost.Category },
];
export const objectStatusCrawl = [
  { text: 'Tất cả', value: '' },
  { text: 'Đã duyệt', value: 'active' }
];

export const objectTypeInput = [
  { text: 'Text', value: 'text' },
  { text: 'Html', value: 'html' }
];

export const role = {
  Admin: 'admin',
  Manager: 'manager',
  Publisher: 'publisher',
  Editor: 'editor',
  Booker: 'booker',
  Approver: 'approver',
  General: 'general',
  XemBaoCao: "xembaocao",
  HLDT_NHAN_VIEN: 'hldt_nhan_vien',
  PHONG_KE_HOACH_TONG_HOP: 'phong_ke_hoach_tong_hop',
  APP_GIAYPHEPHANHNGHE_ACCESS: 'app_giayphephanhnghe_access',
  APP_DANHSACHDUYETHOSO_ACCESS: 'app_danhsachduyethoso_access',
  APP_PHAMVIHANHNGHE_ACCESS: 'app_phamvihanhnghe_access',
};
export const objectRoles = [
  { label: 'Admin', value: role.Admin },
  { label: 'Người thêm và sửa', value: role.Editor },
  { label: 'Quyền xem báo cáo', value: role.XemBaoCao },
  // { label: 'Người phê duyệt', value: role.Approver },
  // { label: 'Người quản lý trang thiết bị', value: role.Manager }
];

export const positionBanner = [
  { label: 'Bên trái', value: 'left' },
  { label: 'Bên phải', value: 'right' },
  { label: 'Trên cùng', value: 'top' },
  { label: 'Phía dưới', value: 'bottom' }
];
export const typeBanner = [
  { value: '1', label: 'Banner ngang' },
  { value: '0', label: 'Banner dọc' }
];

export const typeError = {
  UserName: 'UserName',
  Email: 'Email',
  Code: 'Code'
};

export const messageError = {
  emptyMessage: 'Trường dữ liệu không được để trống',
  emailMessage: 'Địa chỉ email không chính xác',
  minLength6Message: 'Độ dài tối thiểu 6 ký tự',
  minLength8Message: 'Độ dài tối thiểu 8 ký tự',
  maxLength30Message: 'Độ dài không vượt quá 30 ký tự',
  likePassword: 'Mật khẩu không trùng nhau',
  passwordUppercase: 'Mật khẩu phải có ít nhất 1 chữ hoa',
  passwordNumber: 'Mật khẩu phải có ít nhất 1 chữ số',
  passwordSpecial: 'Mật khẩu phải có ít nhất 1 ký tự đặc biệt (!@#$%^&*...)'
};
export const messageToast = {
  messageToastReportExcelSuccess: 'Xuất dữ liệu thành công',
  messageToastReportExcelError: 'Xuất dữ liệu không thành công',
  messageToastDeleteSuccess: 'Xóa dữ liệu thành công',
  messageToastCreateSuccess: 'Thêm mới dữ liệu thành công',
  messageToastUpdateSuccess: 'Cập nhật dữ liệu thành công',
  messageToastDeleteError: 'Xóa dữ liệu không thành công',
  messageToastCreateError: 'Thêm mới dữ liệu không thành công',
  messageToastUpdateError: 'Cập nhật dữ liệu không thành công',
  messageToastTryCatch: 'Gặp lỗi khi thực hiện thao tác, vui lòng thử lại!',
  messageToastChangePassSuccess: 'Đổi mật khẩu thành công',
  messageToastChooseDateError: 'Mời chọn ngày',
  messageToastRecoverPassSuccess: 'Mật khẩu đã được cập nhât, xin mời đăng nhập lại',
  messageToastImportExcelSuccess: 'Dữ liệu excel import thành công',
  messageToastSendEmailSuccess: 'Gửi email thành công',
  messageToastImportExcelErrorLackIdDepartment: 'Dữ liệu excel import thất bại, không tìm được Id của khoa: ',
  messageToastImportExcelErrorLackIdAccount: 'Dữ liệu excel import thất bại, không tìm được Id của tài khoản: '
};

export const dataTypeComponent = [
  { label: 'html', value: 'html' },
  { label: 'ảnh', value: 'image' },
  { label: 'video', value: 'video' },
  { label: 'text', value: 'text' },
  { label: 'nâng cao', value: 'model' }
];

export const styleSelectError = {
  control: (base) => ({
    ...base,
    border: '1px solid #dc3545',
    boxShadow: 'none'
  })
};

export const styleSelectDefault = {
  control: (base) => ({
    ...base
  })
};

export const rangeDate = {
  'Hôm nay': [moment().toDate(), moment().toDate()],
  'Hôm qua': [
    moment().subtract(1, 'days').toDate(),
    moment().subtract(1, 'days').toDate()
  ],
  '7 ngày trước': [moment().subtract(6, 'days').toDate(), moment().toDate()],
  '30 ngày trước': [moment().subtract(29, 'days').toDate(), moment().toDate()],
  'Tháng này': [
    moment().startOf('month').toDate(),
    moment().endOf('month').toDate()
  ],
  'Tháng trước': [
    moment().subtract(1, 'month').startOf('month').toDate(),
    moment().subtract(1, 'month').endOf('month').toDate()
  ]
};
export const rangeDateBooking = {
  'Hôm nay': [moment().toDate(), moment().toDate()],
  'Ngày mai': [
    moment().add(1, 'days').toDate(),
    moment().add(1, 'days').toDate()
  ],
  '7 ngày sau': [moment().toDate(), moment().add(6, 'days').toDate()],
  '30 ngày sau': [moment().toDate(), moment().add(29, 'days').toDate()],
  'Tháng này': [
    moment().startOf('month').toDate(),
    moment().endOf('month').toDate()
  ],
  'Tháng sau': [
    moment().add(1, 'month').startOf('month').toDate(),
    moment().add(1, 'month').endOf('month').toDate()
  ]
};
export const rangeDateReport = {
  'Hôm nay': [moment().startOf('day').toDate(), moment().endOf('day').toDate()],
  'Hôm qua': [
    moment().subtract(1, 'days').startOf('day').toDate(),
    moment().subtract(1, 'days').endOf('day').toDate()
  ],
  '7 ngày trước': [moment().subtract(6, 'days').startOf('day').toDate(), moment().endOf('day').toDate()],
  '30 ngày trước': [moment().subtract(29, 'days').startOf('day').toDate(), moment().endOf('day').toDate()],
  'Tháng này': [
    moment().startOf('month').toDate(),
    moment().endOf('month').toDate()
  ],
  'Tháng trước': [
    moment().subtract(1, 'month').startOf('month').toDate(),
    moment().subtract(1, 'month').endOf('month').toDate()
  ],
  '3 tháng trước': [
    moment().subtract(3, 'months').startOf('month').toDate(),
    moment().endOf('day').toDate()
  ],
  '6 tháng trước': [
    moment().subtract(6, 'months').startOf('month').toDate(),
    moment().endOf('day').toDate()
  ],
  'Năm': [
    moment().startOf('year').toDate(),
    moment().endOf('year').toDate()
  ]
};
export const rangeDateDashboard = {
  // 'Hôm nay': [moment().startOf('day').toDate(), moment().endOf('day').toDate()],
  // 'Hôm qua': [
  //   moment().subtract(1, 'days').startOf('day').toDate(),
  //   moment().subtract(1, 'days').endOf('day').toDate()
  // ],
  '7 ngày trước': [moment().subtract(6, 'days').startOf('day').toDate(), moment().endOf('day').toDate()],
  '30 ngày trước': [moment().subtract(29, 'days').startOf('day').toDate(), moment().endOf('day').toDate()],
  'Tháng này': [
    moment().startOf('month').toDate(),
    moment().endOf('month').toDate()
  ],
  'Tháng trước': [
    moment().subtract(1, 'month').startOf('month').toDate(),
    moment().subtract(1, 'month').endOf('month').toDate()
  ],
  '3 tháng trước': [
    moment().subtract(3, 'months').startOf('month').toDate(),
    moment().endOf('day').toDate()
  ],
  '6 tháng trước': [
    moment().subtract(6, 'months').startOf('month').toDate(),
    moment().endOf('day').toDate()
  ],
  'Năm': [
    moment().startOf('year').toDate(),
    moment().endOf('year').toDate()
  ]
};
export const rangeDateDashboardNotHaveDate = {
  // 'Hôm nay': [moment().startOf('day').toDate(), moment().endOf('day').toDate()],
  // 'Hôm qua': [
  //   moment().subtract(1, 'days').startOf('day').toDate(),
  //   moment().subtract(1, 'days').endOf('day').toDate()
  // ],
  '3 tháng trước': [
    moment().subtract(3, 'months').startOf('month').toDate(),
    moment().endOf('day').toDate()
  ],
  '6 tháng trước': [
    moment().subtract(6, 'months').startOf('month').toDate(),
    moment().endOf('day').toDate()
  ],
  'Năm': [
    moment().startOf('year').toDate(),
    moment().endOf('year').toDate()
  ]
};
export const validInput = (type, value, isCheckSpace = false) => {
  if (
    type.toLowerCase() === 'text' ||
    type.toLowerCase() === 'option' ||
    type.toLowerCase() === 'tagselect' ||
    type.toLowerCase() === 'file'
  ) {
    if (isCheckSpace) {
      if (value.length === 0 || value.includes(' ')) {
        return false;
      }
    } else {
      if (value == null || value.length === 0) {
        return false;
      }
    }
    return true;
    // let regexp = /([^\s])/;
    // let checkingResult = regexp.exec(text);
    // return checkingResult !== null ? true : false;
  }
  if (type.toLowerCase() === 'number') {
    if (value == null || value.length === 0 || value === 0) {
      return false;
    }
    return true;
  }
  if (type.toLowerCase() === 'password') {
    let regexp = /^(?=.{8,})/;
    // let regexp = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    let checkingResult = regexp.exec(value);
    return checkingResult !== null ? true : false;
  }
  if (type.toLowerCase() === 'notspace') {
    let regexp = /^(\w+\S+)$/;
    let checkingResult = regexp.exec(value);
    return checkingResult !== null ? true : false;
  }

  if (type.toLowerCase() === 'phone') {
    let regexp = /^\+?\d+$/;
    try {
      if (regexp.test(value)) {
        const phoneNumber = parsePhoneNumberFromString(
          `Phone: ${parseInt(value)}`,
          'VN',
        );
        if (phoneNumber !== undefined && phoneNumber.isValid()) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    } catch (e) {
      console.error('e', e);
    }

    // let regexp = /^([0|\+[0-9]{1,5})?([0-9]{10,12})$/;
    // let checkingResult = regexp.exec(text);
    // return checkingResult !== null ? true : false;
  }
  if (type.toLowerCase() === 'email') {
    var pattern =
      /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_.-])+\.([a-zA-Z])+([a-zA-Z])+/;
    return pattern.test(value);
  }
  return true;
};

export const trangThaiHocBoSungValue = {
    chuaHoc: 'chuaHoc',
    dangDiHoc: 'dangDiHoc',
    hoanThanh: 'hoanThanh'
};

export const objectTrangThaiHocBoSung = [
    { value: trangThaiHocBoSungValue.chuaHoc, label: 'Chưa học' },
    { value: trangThaiHocBoSungValue.dangDiHoc, label: 'Đang đi học' },
    { value: trangThaiHocBoSungValue.hoanThanh, label: 'Hoàn thành' }
];

export const trangThaiHocPhanValue = {
    choHoc: 'choHoc',
    dangHoc: 'dangHoc',
    hoanThanh: 'hoanThanh'
};

export const objectTrangThaiHocPhan = [
    { value: trangThaiHocPhanValue.choHoc, label: 'Chờ học' },
    { value: trangThaiHocPhanValue.dangHoc, label: 'Đang học' },
    { value: trangThaiHocPhanValue.hoanThanh, label: 'Hoàn thành' }
];

export const loaiHocPhanValue = {
    hocPhan1: 'hocPhan1',
    hocPhan2: 'hocPhan2',
    hocPhan3: 'hocPhan3',
    hocPhan4: 'hocPhan4',
    hocPhan5: 'hocPhan5',
    hocPhan6: 'hocPhan6',
    hocPhan7: 'hocPhan7',
    hocPhan8: 'hocPhan8',
    hocPhan9: 'hocPhan9',
    hocPhan10: 'hocPhan10'
};

export const objectLoaiHocPhan = [
    { value: loaiHocPhanValue.hocPhan1, label: 'Học phần 1' },
    { value: loaiHocPhanValue.hocPhan2, label: 'Học phần 2' },
    { value: loaiHocPhanValue.hocPhan3, label: 'Học phần 3' },
    { value: loaiHocPhanValue.hocPhan4, label: 'Học phần 4' },
    { value: loaiHocPhanValue.hocPhan5, label: 'Học phần 5' },
    { value: loaiHocPhanValue.hocPhan6, label: 'Học phần 6' },
    { value: loaiHocPhanValue.hocPhan7, label: 'Học phần 7' },
    { value: loaiHocPhanValue.hocPhan8, label: 'Học phần 8' },
    { value: loaiHocPhanValue.hocPhan9, label: 'Học phần 9' },
    { value: loaiHocPhanValue.hocPhan10, label: 'Học phần 10' }
];

export const trangThaiChuyenDeValue = {
    chuaThucHien: 'chuaThucHien',
    dangThucHien: 'dangThucHien',
    hoanThanh: 'hoanThanh'
};

export const objectTrangThaiChuyenDe = [
    { value: trangThaiChuyenDeValue.chuaThucHien, label: 'Chưa thực hiện' },
    { value: trangThaiChuyenDeValue.dangThucHien, label: 'Đang thực hiện' },
    { value: trangThaiChuyenDeValue.hoanThanh, label: 'Hoàn thành' }
];

export const trangThaiTieuLuanTongQuanValue = {
    chuaThucHien: 'chuaThucHien',
    dangThucHien: 'dangThucHien',
    hoanThanh: 'hoanThanh'
};

export const objectTrangThaiTieuLuanTongQuan = [
    { value: trangThaiTieuLuanTongQuanValue.chuaThucHien, label: 'Chưa thực hiện' },
    { value: trangThaiTieuLuanTongQuanValue.dangThucHien, label: 'Đang thực hiện' },
    { value: trangThaiTieuLuanTongQuanValue.hoanThanh, label: 'Hoàn thành' }
];

export const loaiChuyenDeValue = {
    chuyenDe1: 'chuyenDe1',
    chuyenDe2: 'chuyenDe2',
    chuyenDe3: 'chuyenDe3',
    chuyenDe4: 'chuyenDe4',
    chuyenDe5: 'chuyenDe5',
    chuyenDe6: 'chuyenDe6',
    chuyenDe7: 'chuyenDe7',
    chuyenDe8: 'chuyenDe8',
    chuyenDe9: 'chuyenDe9',
    chuyenDe10: 'chuyenDe10'
};

export const objectLoaiChuyenDe = [
    { value: loaiChuyenDeValue.chuyenDe1, label: 'Chuyên đề 1' },
    { value: loaiChuyenDeValue.chuyenDe2, label: 'Chuyên đề 2' },
    { value: loaiChuyenDeValue.chuyenDe3, label: 'Chuyên đề 3' },
    { value: loaiChuyenDeValue.chuyenDe4, label: 'Chuyên đề 4' },
    { value: loaiChuyenDeValue.chuyenDe5, label: 'Chuyên đề 5' },
    { value: loaiChuyenDeValue.chuyenDe6, label: 'Chuyên đề 6' },
    { value: loaiChuyenDeValue.chuyenDe7, label: 'Chuyên đề 7' },
    { value: loaiChuyenDeValue.chuyenDe8, label: 'Chuyên đề 8' },
    { value: loaiChuyenDeValue.chuyenDe9, label: 'Chuyên đề 9' },
    { value: loaiChuyenDeValue.chuyenDe10, label: 'Chuyên đề 10' }
];

export const trangThaiGPHNValue = {
  choDuyet: 1,
  daDuyet: 2,
  tuChoi: 3,
};

export const trangThaiCMEValue = {
  all: 0,
  choDuyet: 1,
  daDuyet: 2,
  tuChoi: 3,
};

export const objectTrangThaiCME = [
  { value: trangThaiCMEValue.choDuyet, label: 'Chờ duyệt', color: 'warning' },
  { value: trangThaiCMEValue.daDuyet, label: 'Đã duyệt', color: 'success' },
  { value: trangThaiCMEValue.tuChoi, label: 'Từ chối', color: 'danger' },
];

export const accountGender = {
  male: 'male',
  female: 'female',
  other: 'other'
};

export const objectAccountGender = [
  { label: 'Nam', value: accountGender.male },
  { label: 'Nữ', value: accountGender.female },
  { label: 'Khác', value: accountGender.other },
];

export const objectAccountType = {
  khac: 'khac',
  quanNhan: 'quanNhan'
};

export const objectObjectAccount = [
  { label: 'Quân nhân', value: objectAccountType.quanNhan },
  { label: 'Khác', value: objectAccountType.khac },
];

export const capQuanLyValue = {
  coSo: 0,
  bo: 1,
  nhaNuoc: 2,
  khac: 3
};

export const objectCapQuanLy = [
  { label: 'Cấp Cơ sở', value: capQuanLyValue.coSo },
  { label: 'Cấp Bộ', value: capQuanLyValue.bo },
  { label: 'Cấp Nhà nước', value: capQuanLyValue.nhaNuoc },
  { label: 'Khác', value: capQuanLyValue.khac }
];

export const loaiCanBoHuongDanValue = {
  huongDanChinh: 0,
  huongDanPhu: 1,
  dongHuongDan: 2
};

export const objectLoaiCanBoHuongDan = [
    { label: 'Hướng dẫn chính', value: loaiCanBoHuongDanValue.huongDanChinh },
    { label: 'Hướng dẫn phụ', value: loaiCanBoHuongDanValue.huongDanPhu },
    { label: 'Đồng hướng dẫn', value: loaiCanBoHuongDanValue.dongHuongDan }
];

export const ketQuaTuyenSinhValue = {
    trungTuyen: 0,
    khongTrungTuyen: 1,
    trungTuyenCanBoSung: 2
};

export const objectKetQuaTuyenSinh = [
    { label: 'Trúng tuyển', value: ketQuaTuyenSinhValue.trungTuyen, color: 'success' },
    { label: 'Không trúng tuyển', value: ketQuaTuyenSinhValue.khongTrungTuyen, color: 'danger' },
    { label: 'Trúng tuyển (Cần bổ sung)', value: ketQuaTuyenSinhValue.trungTuyenCanBoSung, color: 'warning' }
];

export const thoiHanDaoTaoValue = {
    baNam: 0,
    bonNam: 1
};

export const objectThoiHanDaoTao = [
    { label: '3 năm', value: thoiHanDaoTaoValue.baNam },
    { label: '4 năm', value: thoiHanDaoTaoValue.bonNam }
];

export const trinhDoDaoTaoTSTSValue = {
    thacSi: 0,
    BSCKI: 1,
    BSCKII: 2,
    BSNT: 3
};

export const objectTrinhDoDaoTaoTSTS = [
    { label: 'Thạc sĩ', value: trinhDoDaoTaoTSTSValue.thacSi },
    { label: 'BSCKI', value: trinhDoDaoTaoTSTSValue.BSCKI },
    { label: 'BSCKII', value: trinhDoDaoTaoTSTSValue.BSCKII },
    { label: 'BSNT', value: trinhDoDaoTaoTSTSValue.BSNT }
];

export const trinhDoThiSinhValue = {
    thacSi: 0,
    BSNT: 1,
    BSCKII: 2,
    BSCKILoaiGioi: 3,
    bacSiLoaiGioi: 4,
    khongDat: 5
};
export const objectTrinhDoThiSinh = [
    { label: 'Thạc sĩ', value: trinhDoThiSinhValue.thacSi },
    { label: 'BSNT', value: trinhDoThiSinhValue.BSNT },
    { label: 'BSCK2', value: trinhDoThiSinhValue.BSCKII },
    { label: 'BSCK1 loại giỏi', value: trinhDoThiSinhValue.BSCKILoaiGioi },
    { label: 'Bác sĩ loại giỏi', value: trinhDoThiSinhValue.bacSiLoaiGioi },
    { label: 'Không đạt', value: trinhDoThiSinhValue.khongDat }
];

export const trinhDoNgoaiNguValue = {
    cuNhanNgonNguAnh: 0,
    ielts65TroLen: 1,
    chungChiC1Khac: 2,
    khongDat: 3
};
export const objectTrinhDoNgoaiNgu = [
    { label: 'Bằng Cử nhân ngôn ngữ Anh', value: trinhDoNgoaiNguValue.cuNhanNgonNguAnh },
    { label: 'Chứng chỉ IELTS >= 6.5 còn hiệu lực tính đến thời điểm dự tuyển', value: trinhDoNgoaiNguValue.ielts65TroLen },
    { label: 'Chứng chỉ Tiếng Anh khác trình độ C1 còn hiệu lực tính đến thời điểm dự tuyển', value: trinhDoNgoaiNguValue.chungChiC1Khac },
    { label: 'Không đạt', value: trinhDoNgoaiNguValue.khongDat }
];

export const danhGiaDeCuongValue = {
    coDeCuong: 0,
    khongCoDeCuong: 1
};
export const objectDanhGiaDeCuong = [
    { label: 'Có đề cương nghiên cứu', value: danhGiaDeCuongValue.coDeCuong },
    { label: 'Không có đề cương', value: danhGiaDeCuongValue.khongCoDeCuong }
];

export const danhGiaKinhNghiemNckhValue = {
    dat: 0,
    khongDat: 1
};
export const objectDanhGiaKinhNghiemNckh = [
    { label: 'Đạt (Có ít nhất 02 bài báo khoa học)', value: danhGiaKinhNghiemNckhValue.dat },
    { label: 'Không đạt', value: danhGiaKinhNghiemNckhValue.khongDat }
];

export const danhGiaCanBoHuongDanValue = {
    coGiayXacNhan: 0,
    khongCoGiayXacNhan: 1
};
export const objectDanhGiaCanBoHuongDan = [
    { label: 'Có giấy xác nhận của CBHD', value: danhGiaCanBoHuongDanValue.coGiayXacNhan },
    { label: 'Không có giấy xác nhận của CBHD', value: danhGiaCanBoHuongDanValue.khongCoGiayXacNhan }
];

export const danhGiaThoiGianCongTacValue = {
    dat: 0,
    khongDat: 1
};
export const objectDanhGiaThoiGianCongTac = [
    { label: 'Đạt', value: danhGiaThoiGianCongTacValue.dat },
    { label: 'Không đạt', value: danhGiaThoiGianCongTacValue.khongDat }
];

export const danhGiaCongVanThuGioiThieuValue = {
    dat: 0,
    khongDat: 1
};
export const objectDanhGiaCongVanThuGioiThieu = [
    { label: 'Đạt', value: danhGiaCongVanThuGioiThieuValue.dat },
    { label: 'Không đạt', value: danhGiaCongVanThuGioiThieuValue.khongDat }
];

export const danhGiaTinhTrangSucKhoeValue = {
    duDieuKien: 0,
    khongDuDieuKien: 1
};
export const objectDanhGiaTinhTrangSucKhoe = [
    { label: 'Đủ điều kiện sức khỏe', value: danhGiaTinhTrangSucKhoeValue.duDieuKien },
    { label: 'Không đủ điều kiện sức khỏe', value: danhGiaTinhTrangSucKhoeValue.khongDuDieuKien }
];

export const trangThaiDuyetHoSoNcsValue = {
    duDieuKien: 0,
    yeuCauBoSung: 1,
    tuChoi: 2
};
export const objectTrangThaiDuyetHoSoNcs = [
    { label: 'Đủ điều kiện (Duyệt)', value: trangThaiDuyetHoSoNcsValue.duDieuKien },
    { label: 'Yêu cầu bổ sung', value: trangThaiDuyetHoSoNcsValue.yeuCauBoSung },
    { label: 'Từ chối', value: trangThaiDuyetHoSoNcsValue.tuChoi }
];

export const trangThaiGuiKetQuaValue = {
    chuaGui: 0,
    daGui: 1
};
export const objectTrangThaiGuiKetQua = [
    { label: 'Chưa gửi', value: trangThaiGuiKetQuaValue.chuaGui },
    { label: 'Đã gửi', value: trangThaiGuiKetQuaValue.daGui }
];

export const trangThaiHoSoNCSValue = {
    choDaoTao: 'choDaoTao',
    dangDaoTao: 'dangDaoTao',
    tamDungDaoTao: 'tamDungDaoTao',
    sapHetHan: 'sapHetHan',
    yeuCauThayDoi: 'yeuCauThayDoi',
    dangGiaHan: 'dangGiaHan', 
    boDaoTao: 'boDaoTao',
    hoanThanh: 'hoanThanh',
    quaHan: 'quaHan',
    hetHan: 'hetHan'
};

export const objectTrangThaiHoSoNCS = [
    { label: 'Chờ đào tạo', value: trangThaiHoSoNCSValue.choDaoTao },
    { label: 'Đang đào tạo', value: trangThaiHoSoNCSValue.dangDaoTao },
    { label: 'Tạm dừng đào tạo', value: trangThaiHoSoNCSValue.tamDungDaoTao },
    { label: 'Sắp hết hạn', value: trangThaiHoSoNCSValue.sapHetHan },
    { label: 'Yêu cầu thay đổi', value: trangThaiHoSoNCSValue.yeuCauThayDoi },
    { label: 'Đang gia hạn', value: trangThaiHoSoNCSValue.dangGiaHan },
    { label: 'Bỏ đào tạo', value: trangThaiHoSoNCSValue.boDaoTao },
    { label: 'Hoàn thành', value: trangThaiHoSoNCSValue.hoanThanh },
    { label: 'Quá hạn', value: trangThaiHoSoNCSValue.quaHan },
    { label: 'Hết hạn', value: trangThaiHoSoNCSValue.hetHan }
];

export const loaiYeuCauValue = {
    thayDoiDeTai: 'thayDoiDeTai',
    thayDoiCBHD: 'thayDoiCBHD',
    giaHanDaoTao: 'giaHanDaoTao'
};

export const objectLoaiYeuCau = [
    { label: 'Thay đổi đề tài', value: loaiYeuCauValue.thayDoiDeTai },
    { label: 'Thay đổi cán bộ hướng dẫn', value: loaiYeuCauValue.thayDoiCBHD },
    { label: 'Gia hạn đào tạo', value: loaiYeuCauValue.giaHanDaoTao }
];

export const trangThaiYeuCauValue = {
    choGui: 'choGui',
    dangXuLy: 'dangXuLy',
    boSung: 'boSung',
    hoanThanh: 'hoanThanh',
    tuChoi: 'tuChoi'
};

export const objectTrangThaiYeuCau = [
    { label: 'Chờ gửi', value: trangThaiYeuCauValue.choGui },
    { label: 'Đang xử lý', value: trangThaiYeuCauValue.dangXuLy },
    { label: 'Yêu cầu bổ sung', value: trangThaiYeuCauValue.boSung },
    { label: 'Hoàn thành', value: trangThaiYeuCauValue.hoanThanh },
    { label: 'Từ chối', value: trangThaiYeuCauValue.tuChoi }
];

export const invoiceStatusOptions = {
    0: { label: 'Yêu cầu phát hành', badge: 'warning' },
    1: { label: 'Đã phát hành', badge: 'success' },
    2: { label: 'Đã kê khai thuế', badge: 'info' },
    3: { label: 'Bị thay thế', badge: 'secondary' },
    4: { label: 'Bị điều chỉnh', badge: 'secondary' },
    5: { label: 'Đã hủy', badge: 'danger' },
    6: { label: 'Yêu cầu thay thế', badge: 'warning' },
    7: { label: 'Yêu cầu điều chỉnh giảm', badge: 'warning' },
    8: { label: 'Yêu cầu hủy', badge: 'warning' }
};

export const invoiceStatusValues = {
    YeuCauPhatHanh: 0,
    PhatHanh: 1,
    DaKeKhaiThue: 2,
    BiThayThe: 3,
    BiDieuChinh: 4,
    Huy: 5,
    YeuCauThayThe: 6,
    YeuCauDieuChinhGiam: 7,
    YeuCauHuy: 8
};

export const invoiceTypeOptions = {
    0: { label: 'Thông thường', badge: 'primary' },
    1: { label: 'Thay thế', badge: 'warning' },
    2: { label: 'Điều chỉnh tăng', badge: 'info' },
    3: { label: 'Điều chỉnh giảm', badge: 'danger' },
    4: { label: 'Điều chỉnh thông tin', badge: 'secondary' }
};

export const invoiceTypeValues = {
    ThongThuong: 0,
    ThayThe: 1,
    DieuChinhTang: 2,
    DieuChinhGiam: 3,
    DieuChinhThongTin: 4
};

export const giaiDoanDaoTaoValue = {
    hoiDongDaoDuc: 0,
    soLieuNghienCuu: 1,
    hocPhanBoSung: 2,
    hocPhanTienSi: 3,
    chuyenDeTienSi: 4,
    tieuLuanTongQuan: 5,
    baoVeCapCoSo: 6,
    phanBienDocLap: 7,
    baoVeCapVien: 8
};

export const objectGiaiDoanDaoTao = [
    { label: 'Hội đồng đạo đức trong nghiên cứu Y sinh học', value: giaiDoanDaoTaoValue.hoiDongDaoDuc },
    { label: 'Số liệu nghiên cứu', value: giaiDoanDaoTaoValue.soLieuNghienCuu },
    { label: 'Học phần bổ sung (đối với NCS trúng tuyển cần bổ sung)', value: giaiDoanDaoTaoValue.hocPhanBoSung },
    { label: 'Học phần tiến sĩ', value: giaiDoanDaoTaoValue.hocPhanTienSi },
    { label: 'Chuyên đề tiến sĩ', value: giaiDoanDaoTaoValue.chuyenDeTienSi },
    { label: 'Tiểu luận tổng quan', value: giaiDoanDaoTaoValue.tieuLuanTongQuan },
    { label: 'Bảo vệ luận án tiến sĩ cấp cơ sở', value: giaiDoanDaoTaoValue.baoVeCapCoSo },
    { label: 'Phản biện độc lập', value: giaiDoanDaoTaoValue.phanBienDocLap },
    { label: 'Bảo vệ luận án cấp viện', value: giaiDoanDaoTaoValue.baoVeCapVien }
];

export const trangThaiHDDDValue = {
    choDuyet: 'choDuyet',
    hoanThanh: 'hoanThanh',
    tuChoi: 'tuChoi'
};

export const objectTrangThaiHDDD = [
    { label: 'Chờ duyệt', value: trangThaiHDDDValue.choDuyet },
    { label: 'Hoàn thành', value: trangThaiHDDDValue.hoanThanh },
    { label: 'Từ chối', value: trangThaiHDDDValue.tuChoi }
];

export const trangThaiKiemTraSoLieuValue = {
    choDuyet: 'choDuyet',
    boSung: 'boSung',
    hoanThanh: 'hoanThanh',
    tuChoi: 'tuChoi'
};

export const objectTrangThaiKiemTraSoLieu = [
    { label: 'Chờ duyệt', value: trangThaiKiemTraSoLieuValue.choDuyet },
    { label: 'Yêu cầu chỉnh sửa', value: trangThaiKiemTraSoLieuValue.boSung },
    { label: 'Hoàn thành', value: trangThaiKiemTraSoLieuValue.hoanThanh },
    { label: 'Từ chối', value: trangThaiKiemTraSoLieuValue.tuChoi }
];

export const trangThaiLaySoLieuValue = {
    choTiepNhan: 'choTiepNhan',
    tiepNhanHoSo: 'tiepNhanHoSo',
    chinhSua: 'chinhSua',
    dangLaySoLieu: 'dangLaySoLieu',
    hoanThanh: 'hoanThanh',
    tuChoi: 'tuChoi'
};

export const objectTrangThaiLaySoLieu = [
    { label: 'Chờ tiếp nhận', value: trangThaiLaySoLieuValue.choTiepNhan },
    { label: 'Tiếp nhận hồ sơ', value: trangThaiLaySoLieuValue.tiepNhanHoSo },
    { label: 'Yêu cầu chỉnh sửa', value: trangThaiLaySoLieuValue.chinhSua },
    { label: 'Đang lấy số liệu', value: trangThaiLaySoLieuValue.dangLaySoLieu },
    { label: 'Hoàn thành', value: trangThaiLaySoLieuValue.hoanThanh },
    { label: 'Từ chối', value: trangThaiLaySoLieuValue.tuChoi }
];

export const loaiHoatDongValue = {
    hocPhanBoSung: 'hocPhanBoSung',
    hocPhanTienSi: 'hocPhanTienSi',
    chuyenDeTienSi: 'chuyenDeTienSi',
    tieuLuanTongQuan: 'tieuLuanTongQuan',
    kiemTraSoLieuLuanAn: 'kiemTraSoLieuLuanAn',
    baoVeCapCoSo: 'baoVeCapCoSo',
    phanBienDocLap: 'phanBienDocLap',
    baoVeCapVien: 'baoVeCapVien'
};

export const objectLoaiHoatDong = [
    { label: 'Học phần bổ sung (nếu có)', value: loaiHoatDongValue.hocPhanBoSung },
    { label: 'Học phần tiến sĩ', value: loaiHoatDongValue.hocPhanTienSi },
    { label: 'Chuyên đề tiến sĩ', value: loaiHoatDongValue.chuyenDeTienSi },
    { label: 'Tiểu luận tổng quan', value: loaiHoatDongValue.tieuLuanTongQuan },
    { label: 'Kiểm tra số liệu luận án', value: loaiHoatDongValue.kiemTraSoLieuLuanAn },
    { label: 'Bảo vệ cấp cơ sở', value: loaiHoatDongValue.baoVeCapCoSo },
    { label: 'Phản biện độc lập', value: loaiHoatDongValue.phanBienDocLap },
    { label: 'Bảo vệ cấp viện', value: loaiHoatDongValue.baoVeCapVien }
];

export const loaiDieuKienValue = {
    hoanThanhCacHocPhan: 'hoanThanhCacHocPhan',
    trinhDoNgoaiNgu: 'trinhDoNgoaiNgu',
    baiBaoKhoaHoc: 'baiBaoKhoaHoc',
    vanBanDongY: 'vanBanDongY',
    danhSachBenhNhan: 'danhSachBenhNhan',
    xacNhanDonVi: 'xacNhanDonVi', 
    luanAnThongQua: 'luanAnThongQua'
};

export const objectLoaiDieuKien = [
    { value: loaiDieuKienValue.hoanThanhCacHocPhan, label: 'Hoàn thành các học phần bổ sung, học phần tiến sĩ' },
    { value: loaiDieuKienValue.trinhDoNgoaiNgu, label: 'Trình độ ngoại ngữ' },
    { value: loaiDieuKienValue.baiBaoKhoaHoc, label: 'Bài báo khoa học' },
    { value: loaiDieuKienValue.vanBanDongY, label: 'Văn bản đồng ý của các đồng tác giả' },
    { value: loaiDieuKienValue.danhSachBenhNhan, label: 'Danh sách bệnh nhân' },
    { value: loaiDieuKienValue.xacNhanDonVi, label: 'Xác nhận đơn vị xử lý số liệu' },
    { value: loaiDieuKienValue.luanAnThongQua, label: 'Luận án đã thông qua bộ môn' }
];

export const loaiDanhGiaValue = {
    dat: 'dat',
    khongDat: 'khongDat'
};

export const objectLoaiDanhGia = [
    { value: loaiDanhGiaValue.dat, label: 'Đạt' },
    { value: loaiDanhGiaValue.khongDat, label: 'Không đạt' }
];

export const trangThaiBaoVeCoSoValue = {
    choQuyetDinh: 'choQuyetDinh',
    choBaoVe: 'choBaoVe',
    hoanThanh: 'hoanThanh'
};

export const objectTrangThaiBaoVeCoSo = [
    { value: trangThaiBaoVeCoSoValue.choQuyetDinh, label: 'Chờ quyết định' },
    { value: trangThaiBaoVeCoSoValue.choBaoVe, label: 'Chờ bảo vệ' },
    { value: trangThaiBaoVeCoSoValue.hoanThanh, label: 'Hoàn thành' }
];

export const trangThaiBaoVeCapVienValue = {
    choQuyetDinh: 'choQuyetDinh',
    choBaove: 'choBaove',
    duDieuKien: 'duDieuKien',
    hoanThanh: 'hoanThanh'
};

export const objectTrangThaiBaoVeCapVien = [
    { value: trangThaiBaoVeCapVienValue.choQuyetDinh, label: 'Chờ quyết định' },
    { value: trangThaiBaoVeCapVienValue.choBaove, label: 'Chờ bảo vệ' },
    { value: trangThaiBaoVeCapVienValue.duDieuKien, label: 'Đủ điều kiện' },
    { value: trangThaiBaoVeCapVienValue.hoanThanh, label: 'Hoàn thành' }
];
